import { CalendarPrimeReact } from "@finanedi.es/storybook"
import { DeclaracionModelo303DtoProps } from "api/DTOs/DeclaracionModelo303Dto"
import { TIPO_CONCURSO_DECLARACION_MODELO } from "api/Types/TipoConcursoDeclaracionModeloEnum"
import { Checkbox, CheckboxChangeParams } from "primereact/checkbox"
import { InputText } from "primereact/inputtext"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { backendDateFormat } from "utils/formatDate"

const IdentificacionModelo303 = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<DeclaracionModelo303DtoProps>
  watch: UseFormWatch<DeclaracionModelo303DtoProps>
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const values = watch()

  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col'>
      <div className='tw-w-full tw-h-auto tw-p-0 tw-flex tw-justify-start tw-items-center tw-gap-3 tw-py-1 tw-border-b tw-border-t tw-border-neutral-25 tw-px-6 tw-min-h-16'>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.identificacionModelo.nif")}
          </span>
          <InputText
            className='tw-text-sm'
            value={values.dp30301?.nif ?? ""}
            disabled
          />
        </div>
        <div className='tw-flex tw-flex-col'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.identificacionModelo.nameRazonSocial")}
          </span>
          <InputText
            className='tw-text-sm'
            value={values.dp30301?.razonSocial ?? ""}
            disabled
          />
        </div>
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box1")}
        </span>
        <Checkbox
          checked={values.dp30301?.tributacionForal}
          onChange={() =>
            setValue(
              "dp30301.tributacionForal",
              !values.dp30301?.tributacionForal
            )
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box2")}
        </span>
        <Checkbox
          checked={values.dp30301?.devolucionMensual}
          onChange={() =>
            setValue(
              "dp30301.devolucionMensual",
              !values.dp30301?.devolucionMensual
            )
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box3")}
        </span>
        <Checkbox
          checked={values.dp30301?.regimenSimple}
          disabled
          onChange={() =>
            setValue("dp30301.regimenSimple", !values.dp30301?.regimenSimple)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box4")}
        </span>
        <Checkbox
          checked={values.dp30301?.autoliquidacionConjunta}
          onChange={() =>
            setValue(
              "dp30301.autoliquidacionConjunta",
              !values.dp30301?.autoliquidacionConjunta
            )
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box5")}
        </span>
        <Checkbox
          checked={values.dp30301?.criterioDeCaja}
          onChange={() =>
            setValue("dp30301.criterioDeCaja", !values.dp30301?.criterioDeCaja)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box6")}
        </span>
        <Checkbox
          checked={values.dp30301?.operacionesCriterioDeCaja}
          onChange={() =>
            setValue(
              "dp30301.operacionesCriterioDeCaja",
              !values.dp30301?.operacionesCriterioDeCaja
            )
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box7")}
        </span>
        <Checkbox
          checked={values.dp30301?.opcionProrrataEspecial}
          onChange={() =>
            setValue(
              "dp30301.opcionProrrataEspecial",
              !values.dp30301?.opcionProrrataEspecial
            )
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box8")}
        </span>
        <Checkbox
          checked={values.dp30301?.revocacionProrrataEspecial}
          onChange={() =>
            setValue(
              "dp30301.revocacionProrrataEspecial",
              !values.dp30301?.revocacionProrrataEspecial
            )
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box9")}
        </span>
        <Checkbox
          checked={values.dp30301?.concursoAcreedores}
          onChange={() => {
            setValue(
              "dp30301.concursoAcreedores",
              !values.dp30301?.concursoAcreedores
            )
          }}
        />
      </div>
      {values.dp30301?.concursoAcreedores && (
        <div className='tw-flex tw-flex-col'>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
            <span className='tw-text-sm tw-text-left tw-flex tw-items-center tw-justify-start tw-col-span-4'>
              {t("taxSummary.declaracion.identificacionModelo.box10")}
            </span>
            <CalendarPrimeReact
              id='fechaDesde'
              name='fechaDesde'
              clearButtonClassName='!tw-hidden'
              value={
                values.dp30301?.fechaConcursoAcreedores
                  ? new Date(values.dp30301.fechaConcursoAcreedores)
                  : undefined
              }
              locale={language}
              onChange={(event) => {
                if (event && event?.value)
                  setValue(
                    "dp30301.fechaConcursoAcreedores",
                    backendDateFormat(event.value)
                  )
              }}
              placeholder='dd/mm/aaaa'
              dateFormat='dd/mm/yy'
              baseZIndex={2302}
              showIcon
            />
          </div>
          <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-7 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
            <span className='tw-text-sm tw-text-left tw-flex tw-items-center tw-justify-start tw-col-span-5'>
              {t("taxSummary.declaracion.identificacionModelo.box11")}
            </span>

            <div className='tw-flex tw-flex-row tw-w-full tw-gap-3 tw-justify-end tw-items-center'>
              <span className='tw-text-sm tw-text-left'>
                {t("taxSummary.declaracion.identificacionModelo.box11typeOne")}
              </span>
              <Checkbox
                checked={
                  values.dp30301?.tipoAutoliquidacionConcursoAcreedores ===
                  TIPO_CONCURSO_DECLARACION_MODELO.PRECONCURSAL
                }
                onChange={(e: CheckboxChangeParams) => {
                  setValue(
                    "dp30301.tipoAutoliquidacionConcursoAcreedores",
                    e.checked
                      ? TIPO_CONCURSO_DECLARACION_MODELO.PRECONCURSAL
                      : null
                  )
                }}
              />
            </div>
            <div className='tw-flex tw-flex-row tw-w-full tw-gap-3 tw-justify-end tw-items-center'>
              <span className='tw-text-sm tw-text-left'>
                {t("taxSummary.declaracion.identificacionModelo.box11typeTwo")}
              </span>
              <Checkbox
                checked={
                  values.dp30301?.tipoAutoliquidacionConcursoAcreedores ===
                  TIPO_CONCURSO_DECLARACION_MODELO.POSTCONCURSAL
                }
                onChange={(e: CheckboxChangeParams) => {
                  setValue(
                    "dp30301.tipoAutoliquidacionConcursoAcreedores",
                    e.checked
                      ? TIPO_CONCURSO_DECLARACION_MODELO.POSTCONCURSAL
                      : null
                  )
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left'>
          {t("taxSummary.declaracion.identificacionModelo.box12")}
        </span>
        <Checkbox
          checked={values.dp30301?.voluntarioSii}
          onChange={() =>
            setValue("dp30301.voluntarioSii", !values.dp30301?.voluntarioSii)
          }
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-grid tw-grid-cols-5 tw-py-1 tw-gap-3 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left tw-col-span-4 tw-flex tw-justify-start tw-items-center'>
          {t("taxSummary.declaracion.identificacionModelo.box13")}
        </span>
        <InputText
          className='tw-text-sm'
          value={values.dp30301?.exoneradoDeclaracion ?? ""}
        />
      </div>
      <div className='tw-w-full tw-h-fit tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-1 tw-border-b tw-border-neutral-25 tw-px-6 tw-min-h-12'>
        <span className='tw-text-sm tw-text-left tw-col-span-4 tw-flex tw-justify-be tw-items-center'>
          {t("taxSummary.declaracion.identificacionModelo.box14")}
        </span>
        <Checkbox
          checked={values.dp30301?.volumenOperacionDistintoCero}
          onChange={() =>
            setValue(
              "dp30301.volumenOperacionDistintoCero",
              !values.dp30301?.volumenOperacionDistintoCero
            )
          }
        />
      </div>
      <span className='tw-text-xs tw-text-right tw-w-full tw-py-1 tw-px-6'>
        {t("taxSummary.declaracion.infoMsg")}
      </span>
    </div>
  )
}

export default IdentificacionModelo303
